import { Navigate } from "react-router-dom";

export const AuthCallbackPage = () => <Navigate to="/" replace />;
